import { render } from "./reporterApplyInstitutionQuery.vue?vue&type=template&id=d875bc3a&scoped=true"
import script from "./reporterApplyInstitutionQuery.vue?vue&type=script&lang=js"
export * from "./reporterApplyInstitutionQuery.vue?vue&type=script&lang=js"

import "./reporterApplyInstitutionQuery.vue?vue&type=style&index=0&id=d875bc3a&lang=less&scoped=true"
import "./reporterApplyInstitutionQuery.vue?vue&type=style&index=1&id=d875bc3a&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d875bc3a"]])

export default __exports__